import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Heading from '@atlaskit/heading';

export const i18n = defineMessages({
	headerTitle: {
		id: 'company-hub.hub-settings.general.header-title',
		defaultMessage: 'Your hub',
		description: 'Header title for the general tab in company hub settings page',
	},
});

export const GeneralPageContent = () => {
	return (
		<Heading size="medium">
			<FormattedMessage {...i18n.headerTitle} />
		</Heading>
	);
};
